import _ from 'lodash';
import CreditCardQuestionsApi from '../../api/CreditCardQuestionsApi';
import sourcesFieldsList from '../../constants/sourcesFields';

const state = {
  creditCardQuestions: [],
};

const getters = {
  questionsByAccount: state => _.groupBy(state.creditCardQuestions, 'accountNumberPiiValue'),
};

const actions = {
  async fetchCreditCardsQuestions({ commit }) {
    const creditCardQuestions = await CreditCardQuestionsApi.fetchCreditCardQuestions();
    const questionsWithSourceName = _.filter(creditCardQuestions, question => question.sourceName);
    commit('setCreditCardQuestions', _.map(questionsWithSourceName, addSrouceToQuestion));
  },
};

// mutations
const mutations = {
  setCreditCardQuestions(state, creditCardQuestions) {
    state.creditCardQuestions = creditCardQuestions;
  },
};

function addSrouceToQuestion(question) {
  const source = _.find(sourcesFieldsList.allSourceFields, { sourceName: question.sourceName });
  return {
    ...question,
    source,
  };
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
